import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IAlertDescriptionProps from "./type";
import stylesheet, {
    ALERT_DESCRIPTION_VARIANT
} from "./stylesheet";
import type {
    AlertPartContentProps
} from "../../type";
import {
    withAlertContext
} from "../../context";
import Text from "../../../text";

const AlertDescriptionContent: FC<AlertPartContentProps<IAlertDescriptionProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const renderContent = () => {
        if(typeof children !== "string" && typeof children !== "number") {
            return children;
        }

        return <Text
            customColor={context.currentColors.descriptionColor}
            variant={ALERT_DESCRIPTION_VARIANT}
            customTheme={customTheme}
        >
            {children}
        </Text>;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.container
        ]}
    >
        {renderContent()}
    </View>;
};
export default withAlertContext("description", AlertDescriptionContent);
